import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, withModifiers as _withModifiers, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = {
  key: 0,
  class: "horizontal-scroll"
}
const _hoisted_3 = { key: 0 }
const _hoisted_4 = {
  key: 0,
  class: "ion-text-center"
}
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = {
  key: 0,
  class: "ion-text-center"
}
const _hoisted_8 = { key: 1 }
const _hoisted_9 = { key: 2 }
const _hoisted_10 = {
  key: 0,
  class: "ion-text-center"
}
const _hoisted_11 = { style: {"display":"flex","align-items":"center","flex-wrap":"wrap","gap":"8px","margin-bottom":"8px"} }
const _hoisted_12 = {
  key: 0,
  style: {"margin":"8px 0"}
}
const _hoisted_13 = { class: "ion-text-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_segment_button = _resolveComponent("ion-segment-button")!
  const _component_ion_segment = _resolveComponent("ion-segment")!
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")!
  const _component_ion_searchbar = _resolveComponent("ion-searchbar")!
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_label = _resolveComponent("ion-label")!
  const _component_ion_item = _resolveComponent("ion-item")!
  const _component_ion_checkbox = _resolveComponent("ion-checkbox")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_popover = _resolveComponent("ion-popover")!
  const _component_ion_col = _resolveComponent("ion-col")!
  const _component_ion_row = _resolveComponent("ion-row")!
  const _component_ion_chip = _resolveComponent("ion-chip")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_buttons = _resolveComponent("ion-buttons")!
  const _component_ion_list_header = _resolveComponent("ion-list-header")!
  const _component_ion_grid = _resolveComponent("ion-grid")!
  const _component_ion_header = _resolveComponent("ion-header")!
  const _component_ion_spinner = _resolveComponent("ion-spinner")!
  const _component_ag_grid_vue = _resolveComponent("ag-grid-vue")!
  const _component_ion_title = _resolveComponent("ion-title")!
  const _component_ion_textarea = _resolveComponent("ion-textarea")!
  const _component_ion_modal = _resolveComponent("ion-modal")!
  const _component_ion_alert = _resolveComponent("ion-alert")!
  const _component_ion_select_option = _resolveComponent("ion-select-option")!
  const _component_ion_select = _resolveComponent("ion-select")!
  const _component_ion_card = _resolveComponent("ion-card")!
  const _component_ion_fab_button = _resolveComponent("ion-fab-button")!
  const _component_ion_fab = _resolveComponent("ion-fab")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_ion_header, null, {
      default: _withCtx(() => [
        _createVNode(_component_ion_grid, {
          class: "ion-no-padding",
          fixed: ""
        }, {
          default: _withCtx(() => [
            _createVNode(_component_ion_toolbar, null, {
              default: _withCtx(() => [
                _createVNode(_component_ion_segment, {
                  modelValue: _ctx.selectedView,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedView) = $event)),
                  mode: "ios",
                  scrollable: ""
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_segment_button, { value: "secondary-school-student" }, {
                      default: _withCtx(() => _cache[37] || (_cache[37] = [
                        _createTextVNode("Student")
                      ])),
                      _: 1
                    }),
                    _createVNode(_component_ion_segment_button, { value: "teacher" }, {
                      default: _withCtx(() => _cache[38] || (_cache[38] = [
                        _createTextVNode("Teacher")
                      ])),
                      _: 1
                    }),
                    _createVNode(_component_ion_segment_button, { value: "school" }, {
                      default: _withCtx(() => _cache[39] || (_cache[39] = [
                        _createTextVNode("School")
                      ])),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }),
            (_ctx.selectedView != 'school')
              ? (_openBlock(), _createBlock(_component_ion_toolbar, { key: 0 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_searchbar, {
                      style: {"padding-bottom":"0","height":"28px"},
                      mode: "ios",
                      modelValue: _ctx.searchKeyword,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.searchKeyword) = $event))
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            _createVNode(_component_ion_toolbar, null, {
              default: _withCtx(() => [
                _createVNode(_component_ion_row, { class: "filter-items" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_col, {
                      "size-xs": "6",
                      "size-md": "6",
                      "size-lg": "6",
                      "size-xl": "3"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_item, {
                          lines: "none",
                          class: "filter-item",
                          color: _ctx.selectedFilterCheckboxVals('bands').length == 0 ? 'light' : 'primary',
                          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.setPopoverOpen('bands', true, $event))),
                          button: ""
                        }, {
                          default: _withCtx(() => [
                            _withDirectives(_createVNode(_component_ion_icon, {
                              slot: "start",
                              icon: _ctx.filter
                            }, null, 8, ["icon"]), [
                              [_vShow, _ctx.selectedFilterCheckboxVals('bands').length == 0]
                            ]),
                            _withDirectives(_createVNode(_component_ion_icon, {
                              slot: "start",
                              icon: _ctx.closeCircle,
                              onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.updateFilters('bands', {})), ["stop"]))
                            }, null, 8, ["icon"]), [
                              [_vShow, _ctx.selectedFilterCheckboxVals('bands').length > 0]
                            ]),
                            _createVNode(_component_ion_label, { class: "ion-text-nowrap" }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.selectedFilterCheckboxVals('bands').length == 0 ? "Banding" : _ctx.selectedFilterCheckboxVals('bands').sort().join(', ')), 1)
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 8, ["color"]),
                        _createVNode(_component_ion_popover, {
                          isOpen: _ctx.popoverState.bands,
                          event: _ctx.popoverEvent,
                          "dismiss-on-select": false,
                          onDidDismiss: _cache[4] || (_cache[4] = ($event: any) => (_ctx.setPopoverOpen('bands', false, $event)))
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_content, null, {
                              default: _withCtx(() => [
                                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(['1A', '1B', '1C', '2A', '2B', '2C', '3A', '3B', '3C'], (band) => {
                                  return _createVNode(_component_ion_item, {
                                    lines: "full",
                                    key: band,
                                    button: ""
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_ion_checkbox, {
                                        modelValue: _ctx.filters.bands[band],
                                        "onUpdate:modelValue": ($event: any) => ((_ctx.filters.bands[band]) = $event),
                                        value: band
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_ion_label, null, {
                                            default: _withCtx(() => [
                                              _createTextVNode(_toDisplayString(band), 1)
                                            ]),
                                            _: 2
                                          }, 1024)
                                        ]),
                                        _: 2
                                      }, 1032, ["modelValue", "onUpdate:modelValue", "value"])
                                    ]),
                                    _: 2
                                  }, 1024)
                                }), 64))
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 8, ["isOpen", "event"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_ion_col, {
                      "size-xs": "6",
                      "size-md": "6",
                      "size-lg": "6",
                      "size-xl": "3"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_item, {
                          lines: "none",
                          class: "filter-item",
                          color: _ctx.filters.schoolIds.length == 0 ? 'light' : 'primary',
                          onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.openSchoolSelectModal())),
                          button: ""
                        }, {
                          default: _withCtx(() => [
                            _withDirectives(_createVNode(_component_ion_icon, {
                              slot: "start",
                              icon: _ctx.filter
                            }, null, 8, ["icon"]), [
                              [_vShow, _ctx.filters.schoolIds.length == 0]
                            ]),
                            _withDirectives(_createVNode(_component_ion_icon, {
                              slot: "start",
                              icon: _ctx.closeCircle,
                              onClick: _cache[5] || (_cache[5] = _withModifiers(($event: any) => (_ctx.updateFilters('schoolIds', [])), ["stop"]))
                            }, null, 8, ["icon"]), [
                              [_vShow, _ctx.filters.schoolIds.length > 0]
                            ]),
                            _createVNode(_component_ion_label, { class: "ion-text-nowrap" }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.filters.schoolIds.length == 0 ? "School" : `${_ctx.filters.schoolIds.length} school${_ctx.filters.schoolIds.length > 1 ? 's' : ''}`), 1)
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 8, ["color"])
                      ]),
                      _: 1
                    }),
                    (_ctx.selectedView == 'secondary-school-student')
                      ? (_openBlock(), _createBlock(_component_ion_col, {
                          key: 0,
                          "size-xs": "6",
                          "size-md": "6",
                          "size-lg": "6",
                          "size-xl": "3"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_item, {
                              lines: "none",
                              class: "filter-item",
                              color: _ctx.selectedFilterCheckboxVals('electives').length == 0 ? 'light' : 'primary',
                              onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.setPopoverOpen('electives', true, $event))),
                              button: ""
                            }, {
                              default: _withCtx(() => [
                                _withDirectives(_createVNode(_component_ion_icon, {
                                  slot: "start",
                                  icon: _ctx.filter
                                }, null, 8, ["icon"]), [
                                  [_vShow, _ctx.selectedFilterCheckboxVals('electives').length == 0]
                                ]),
                                _withDirectives(_createVNode(_component_ion_icon, {
                                  slot: "start",
                                  icon: _ctx.closeCircle,
                                  onClick: _cache[7] || (_cache[7] = _withModifiers(($event: any) => (_ctx.updateFilters('electives', {})), ["stop"]))
                                }, null, 8, ["icon"]), [
                                  [_vShow, _ctx.selectedFilterCheckboxVals('electives').length > 0]
                                ]),
                                _createVNode(_component_ion_label, null, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.selectedFilterCheckboxVals('electives').length == 0 ? "Electives" : `${_ctx.selectedFilterCheckboxVals('electives').length} elective${_ctx.selectedFilterCheckboxVals('electives').length > 1 ? 's' : ''} selected`), 1)
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }, 8, ["color"]),
                            _createVNode(_component_ion_popover, {
                              isOpen: _ctx.popoverState.electives,
                              event: _ctx.popoverEvent,
                              "dismiss-on-select": false,
                              onDidDismiss: _cache[9] || (_cache[9] = ($event: any) => (_ctx.setPopoverOpen('electives', false, $event)))
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_ion_content, null, {
                                  default: _withCtx(() => [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.electives, (elective) => {
                                      return (_openBlock(), _createBlock(_component_ion_item, {
                                        lines: "full",
                                        key: elective.id,
                                        button: ""
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_ion_checkbox, {
                                            modelValue: _ctx.filters.electives[elective.name],
                                            "onUpdate:modelValue": ($event: any) => ((_ctx.filters.electives[elective.name]) = $event),
                                            value: elective.name
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_ion_label, null, {
                                                default: _withCtx(() => [
                                                  _createTextVNode(_toDisplayString(elective.name), 1)
                                                ]),
                                                _: 2
                                              }, 1024)
                                            ]),
                                            _: 2
                                          }, 1032, ["modelValue", "onUpdate:modelValue", "value"])
                                        ]),
                                        _: 2
                                      }, 1024))
                                    }), 128))
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }, 8, ["isOpen", "event"])
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    (_ctx.selectedView == 'secondary-school-student')
                      ? (_openBlock(), _createBlock(_component_ion_col, {
                          key: 1,
                          "size-xs": "6",
                          "size-md": "6",
                          "size-lg": "6",
                          "size-xl": "3"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_item, {
                              lines: "none",
                              class: "filter-item",
                              color: _ctx.filters.jupasChoiceActive && _ctx.localJupasConditions.length > 0 ? 'primary' : 'light',
                              onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.openJUPASChoiceConditionModal())),
                              button: ""
                            }, {
                              default: _withCtx(() => [
                                _withDirectives(_createVNode(_component_ion_icon, {
                                  slot: "start",
                                  icon: _ctx.filter
                                }, null, 8, ["icon"]), [
                                  [_vShow, !_ctx.filters.jupasChoiceActive || _ctx.localJupasConditions.length == 0]
                                ]),
                                _withDirectives(_createVNode(_component_ion_icon, {
                                  slot: "start",
                                  icon: _ctx.closeCircle,
                                  onClick: _cache[10] || (_cache[10] = _withModifiers(($event: any) => (_ctx.updateFilters('jupasChoiceActive', false)), ["stop"]))
                                }, null, 8, ["icon"]), [
                                  [_vShow, _ctx.filters.jupasChoiceActive && _ctx.localJupasConditions.length > 0]
                                ]),
                                _createVNode(_component_ion_label, { class: "ion-text-nowrap" }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.filters.jupasChoiceActive && _ctx.localJupasConditions.length > 0 ? `${_ctx.localJupasConditions.length} JUPAS Choice Condition${_ctx.localJupasConditions.length > 1 ? 's' : ''}` : "JUPAS Choices"), 1)
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }, 8, ["color"])
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    (_ctx.selectedView == 'teacher')
                      ? (_openBlock(), _createBlock(_component_ion_col, {
                          key: 2,
                          "size-xs": "6",
                          "size-md": "6",
                          "size-lg": "6",
                          "size-xl": "3"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_item, {
                              lines: "none",
                              class: "filter-item",
                              color: _ctx.selectedFilterCheckboxVals('schoolRoles').length == 0 ? 'light' : 'primary',
                              onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.setPopoverOpen('schoolRoles', true, $event))),
                              button: ""
                            }, {
                              default: _withCtx(() => [
                                _withDirectives(_createVNode(_component_ion_icon, {
                                  slot: "start",
                                  icon: _ctx.filter
                                }, null, 8, ["icon"]), [
                                  [_vShow, _ctx.selectedFilterCheckboxVals('schoolRoles').length == 0]
                                ]),
                                _withDirectives(_createVNode(_component_ion_icon, {
                                  slot: "start",
                                  icon: _ctx.closeCircle,
                                  onClick: _cache[12] || (_cache[12] = _withModifiers(($event: any) => (_ctx.updateFilters('schoolRoles', {})), ["stop"]))
                                }, null, 8, ["icon"]), [
                                  [_vShow, _ctx.selectedFilterCheckboxVals('schoolRoles').length > 0]
                                ]),
                                _createVNode(_component_ion_label, { class: "ion-text-nowrap" }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.selectedFilterCheckboxVals('schoolRoles').length == 0 ? "School Roles" : _ctx.selectedFilterCheckboxVals('schoolRoles').sort().join(', ')), 1)
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }, 8, ["color"]),
                            _createVNode(_component_ion_popover, {
                              isOpen: _ctx.popoverState.schoolRoles,
                              event: _ctx.popoverEvent,
                              "dismiss-on-select": false,
                              onDidDismiss: _cache[14] || (_cache[14] = ($event: any) => (_ctx.setPopoverOpen('schoolRoles', false, $event)))
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_ion_content, null, {
                                  default: _withCtx(() => [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.visibleSchoolRoles, (role) => {
                                      return (_openBlock(), _createBlock(_component_ion_item, {
                                        lines: "full",
                                        key: role,
                                        button: ""
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_ion_checkbox, {
                                            modelValue: _ctx.filters.schoolRoles[role],
                                            "onUpdate:modelValue": ($event: any) => ((_ctx.filters.schoolRoles[role]) = $event),
                                            value: role
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_ion_label, null, {
                                                default: _withCtx(() => [
                                                  _createTextVNode(_toDisplayString(role), 1)
                                                ]),
                                                _: 2
                                              }, 1024)
                                            ]),
                                            _: 2
                                          }, 1032, ["modelValue", "onUpdate:modelValue", "value"])
                                        ]),
                                        _: 2
                                      }, 1024))
                                    }), 128))
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }, 8, ["isOpen", "event"])
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    _createVNode(_component_ion_col, {
                      "size-xs": "6",
                      "size-md": "6",
                      "size-lg": "6",
                      "size-xl": "3"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_item, {
                          lines: "none",
                          class: "filter-item",
                          color: _ctx.selectedFilterCheckboxVals('schoolDistricts').length == 0 ? 'light' : 'primary',
                          onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.setPopoverOpen('schoolDistricts', true, $event))),
                          button: ""
                        }, {
                          default: _withCtx(() => [
                            _withDirectives(_createVNode(_component_ion_icon, {
                              slot: "start",
                              icon: _ctx.filter
                            }, null, 8, ["icon"]), [
                              [_vShow, _ctx.selectedFilterCheckboxVals('schoolDistricts').length == 0]
                            ]),
                            _withDirectives(_createVNode(_component_ion_icon, {
                              slot: "start",
                              icon: _ctx.closeCircle,
                              onClick: _cache[15] || (_cache[15] = _withModifiers(($event: any) => (_ctx.updateFilters('schoolDistricts', {})), ["stop"]))
                            }, null, 8, ["icon"]), [
                              [_vShow, _ctx.selectedFilterCheckboxVals('schoolDistricts').length > 0]
                            ]),
                            _createVNode(_component_ion_label, { class: "ion-text-nowrap" }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.selectedFilterCheckboxVals('schoolDistricts').length == 0 ? "School Districts" : _ctx.selectedFilterCheckboxVals('schoolDistricts').sort().join(', ')), 1)
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 8, ["color"]),
                        _createVNode(_component_ion_popover, {
                          isOpen: _ctx.popoverState.schoolDistricts,
                          event: _ctx.popoverEvent,
                          "dismiss-on-select": false,
                          onDidDismiss: _cache[17] || (_cache[17] = ($event: any) => (_ctx.setPopoverOpen('schoolDistricts', false, $event)))
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_content, null, {
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.visibleSchoolDistricts, (district) => {
                                  return (_openBlock(), _createBlock(_component_ion_item, {
                                    lines: "full",
                                    key: district,
                                    button: ""
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_ion_checkbox, {
                                        modelValue: _ctx.filters.schoolDistricts[district],
                                        "onUpdate:modelValue": ($event: any) => ((_ctx.filters.schoolDistricts[district]) = $event),
                                        value: district
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_ion_label, null, {
                                            default: _withCtx(() => [
                                              _createTextVNode(_toDisplayString(district), 1)
                                            ]),
                                            _: 2
                                          }, 1024)
                                        ]),
                                        _: 2
                                      }, 1032, ["modelValue", "onUpdate:modelValue", "value"])
                                    ]),
                                    _: 2
                                  }, 1024))
                                }), 128))
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 8, ["isOpen", "event"])
                      ]),
                      _: 1
                    }),
                    (_ctx.selectedView == 'secondary-school-student')
                      ? (_openBlock(), _createBlock(_component_ion_col, {
                          key: 3,
                          "size-xs": "6",
                          "size-md": "6",
                          "size-lg": "6",
                          "size-xl": "3"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_item, {
                              lines: "none",
                              class: "filter-item",
                              color: _ctx.selectedFilterCheckboxVals('rankInForms').length == 0 ? 'light' : 'primary',
                              onClick: _cache[19] || (_cache[19] = ($event: any) => (_ctx.setPopoverOpen('rankInForms', true, $event))),
                              button: ""
                            }, {
                              default: _withCtx(() => [
                                _withDirectives(_createVNode(_component_ion_icon, {
                                  slot: "start",
                                  icon: _ctx.filter
                                }, null, 8, ["icon"]), [
                                  [_vShow, _ctx.selectedFilterCheckboxVals('rankInForms').length == 0]
                                ]),
                                _withDirectives(_createVNode(_component_ion_icon, {
                                  slot: "start",
                                  icon: _ctx.closeCircle,
                                  onClick: _cache[18] || (_cache[18] = _withModifiers(($event: any) => (_ctx.updateFilters('rankInForms', {})), ["stop"]))
                                }, null, 8, ["icon"]), [
                                  [_vShow, _ctx.selectedFilterCheckboxVals('rankInForms').length > 0]
                                ]),
                                _createVNode(_component_ion_label, { class: "ion-text-nowrap" }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.selectedFilterCheckboxVals('rankInForms').length == 0 ? "Rank in Form" : _ctx.selectedFilterCheckboxVals('rankInForms').sort().join(', ')), 1)
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }, 8, ["color"]),
                            _createVNode(_component_ion_popover, {
                              isOpen: _ctx.popoverState.rankInForms,
                              event: _ctx.popoverEvent,
                              "dismiss-on-select": false,
                              onDidDismiss: _cache[20] || (_cache[20] = ($event: any) => (_ctx.setPopoverOpen('rankInForms', false, $event)))
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_ion_content, null, {
                                  default: _withCtx(() => [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.optionRankInForms, (rankInForm) => {
                                      return (_openBlock(), _createBlock(_component_ion_item, {
                                        lines: "full",
                                        key: rankInForm,
                                        button: ""
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_ion_checkbox, {
                                            modelValue: _ctx.filters.rankInForms[rankInForm],
                                            "onUpdate:modelValue": ($event: any) => ((_ctx.filters.rankInForms[rankInForm]) = $event),
                                            value: rankInForm
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_ion_label, null, {
                                                default: _withCtx(() => [
                                                  _createTextVNode(_toDisplayString(rankInForm), 1)
                                                ]),
                                                _: 2
                                              }, 1024)
                                            ]),
                                            _: 2
                                          }, 1032, ["modelValue", "onUpdate:modelValue", "value"])
                                        ]),
                                        _: 2
                                      }, 1024))
                                    }), 128))
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }, 8, ["isOpen", "event"])
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }),
                _createVNode(_component_ion_segment, {
                  modelValue: _ctx.filters.banding,
                  "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.filters.banding) = $event)),
                  mode: "ios",
                  scrollable: "",
                  style: {"margin-top":"2px"}
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_segment_button, { value: "all" }, {
                      default: _withCtx(() => _cache[40] || (_cache[40] = [
                        _createTextVNode("All")
                      ])),
                      _: 1
                    }),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((_ctx.selectedFilterCheckboxVals('bands').length == 0 ? ['1A', '1B', '1C', '2A', '2B', '2C', '3A', '3B', '3C'] : _ctx.selectedFilterCheckboxVals('bands')), (band) => {
                      return (_openBlock(), _createBlock(_component_ion_segment_button, {
                        key: band,
                        value: band
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(band), 1)
                        ]),
                        _: 2
                      }, 1032, ["value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"]),
                (_ctx.selectedView == 'secondary-school-student')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                      _createVNode(_component_ion_segment, {
                        modelValue: _ctx.filters.yearDSE,
                        "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.filters.yearDSE) = $event)),
                        mode: "ios",
                        scrollable: ""
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_segment_button, { value: "all" }, {
                            default: _withCtx(() => _cache[41] || (_cache[41] = [
                              _createTextVNode("All")
                            ])),
                            _: 1
                          }),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dseYears, (year) => {
                            return (_openBlock(), _createBlock(_component_ion_segment_button, {
                              key: year,
                              value: year
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode("DSE " + _toDisplayString(year), 1)
                              ]),
                              _: 2
                            }, 1032, ["value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue"]),
                      _createVNode(_component_ion_segment, {
                        modelValue: _ctx.filters.status,
                        "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.filters.status) = $event)),
                        mode: "ios",
                        scrollable: "",
                        style: {"margin-top":"2px"}
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_segment_button, { value: "all" }, {
                            default: _withCtx(() => _cache[42] || (_cache[42] = [
                              _createTextVNode("All")
                            ])),
                            _: 1
                          }),
                          _createVNode(_component_ion_segment_button, { value: "incomplete" }, {
                            default: _withCtx(() => _cache[43] || (_cache[43] = [
                              _createTextVNode("Chose < 6 programs")
                            ])),
                            _: 1
                          }),
                          _createVNode(_component_ion_segment_button, { value: "missing-target-scores" }, {
                            default: _withCtx(() => _cache[44] || (_cache[44] = [
                              _createTextVNode("Missing Target Scores")
                            ])),
                            _: 1
                          }),
                          _createVNode(_component_ion_segment_button, { value: "complete" }, {
                            default: _withCtx(() => _cache[45] || (_cache[45] = [
                              _createTextVNode("Completed")
                            ])),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["modelValue"]),
                      _createVNode(_component_ion_segment, {
                        modelValue: _ctx.filterAppliedSessionId,
                        "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.filterAppliedSessionId) = $event)),
                        mode: "ios",
                        scrollable: "",
                        style: {"margin-top":"2px"}
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_segment_button, { value: "all" }, {
                            default: _withCtx(() => _cache[46] || (_cache[46] = [
                              _createTextVNode("-")
                            ])),
                            _: 1
                          }),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filterSessions, (name, sessionId) => {
                            return (_openBlock(), _createBlock(_component_ion_segment_button, {
                              key: sessionId,
                              value: sessionId
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(name), 1)
                              ]),
                              _: 2
                            }, 1032, ["value"]))
                          }), 128)),
                          _createVNode(_component_ion_segment_button, { value: "joined-more-than-1" }, {
                            default: _withCtx(() => _cache[47] || (_cache[47] = [
                              _createTextVNode("Joined more than 1")
                            ])),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]))
                  : _createCommentVNode("", true),
                _createVNode(_component_ion_list_header, {
                  color: "primary",
                  style: {"min-height":"36px"}
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_label, null, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.recipientCountDescription), 1)
                      ]),
                      _: 1
                    }),
                    (_ctx.filters.schoolIds.length > 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.visibleSchoolIds as any, (schoolId) => {
                            return (_openBlock(), _createBlock(_component_ion_chip, {
                              class: "small-chip",
                              key: schoolId
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_ion_label, null, {
                                  default: _withCtx(() => [
                                    _createElementVNode("b", null, _toDisplayString(schoolId.toUpperCase()), 1)
                                  ]),
                                  _: 2
                                }, 1024),
                                _createVNode(_component_ion_icon, {
                                  icon: _ctx.close,
                                  onClick: _withModifiers(($event: any) => (_ctx.updateFilters('schoolIds', _ctx.filters.schoolIds.filter(s => s != schoolId))), ["stop"])
                                }, null, 8, ["icon", "onClick"])
                              ]),
                              _: 2
                            }, 1024))
                          }), 128))
                        ]))
                      : _createCommentVNode("", true),
                    (['secondary-school-student', 'teacher'].includes(_ctx.selectedView))
                      ? (_openBlock(), _createBlock(_component_ion_buttons, { key: 1 }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_button, {
                              size: "small",
                              onClick: _cache[25] || (_cache[25] = ($event: any) => (_ctx.modalState.sendMessage = true))
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_ion_icon, {
                                  size: "small",
                                  slot: "icon-only",
                                  icon: _ctx.sendOutline
                                }, null, 8, ["icon"])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_ion_content, null, {
      default: _withCtx(() => [
        _createVNode(_component_ion_grid, {
          class: "ion-no-padding",
          fixed: ""
        }, {
          default: _withCtx(() => [
            (_ctx.selectedView == 'secondary-school-student')
              ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                  (!_ctx.fetchedAllStudents)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_4, [
                        _createVNode(_component_ion_spinner)
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_5, [
                        _createVNode(_component_ag_grid_vue, {
                          class: "ag-theme-alpine",
                          suppressRowClickSelection: true,
                          rowSelection: "multiple",
                          autoSizeStrategy: { type: 'fitCellContents' },
                          rowData: _ctx.filteredStudents,
                          columnDefs: _ctx.studentColDefs,
                          style: {"height":"500px"},
                          modules: _ctx.agGridModules,
                          pagination: true,
                          onSelectionChanged: _ctx.onSelectionChanged,
                          getRowStyle: _ctx.getRowStyle
                        }, null, 8, ["rowData", "columnDefs", "modules", "onSelectionChanged", "getRowStyle"])
                      ]))
                ]))
              : (_ctx.selectedView == 'teacher')
                ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                    (!_ctx.fetchedAllTeachers)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_7, [
                          _createVNode(_component_ion_spinner)
                        ]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_8, [
                          _createVNode(_component_ag_grid_vue, {
                            class: "ag-theme-alpine",
                            suppressRowClickSelection: true,
                            rowSelection: "multiple",
                            autoSizeStrategy: { type: 'fitCellContents' },
                            rowData: _ctx.filteredTeachers,
                            columnDefs: _ctx.teacherColDefs,
                            style: {"height":"500px"},
                            modules: _ctx.agGridModules,
                            pagination: true,
                            onSelectionChanged: _ctx.onSelectionChanged,
                            getRowStyle: _ctx.getRowStyle
                          }, null, 8, ["rowData", "columnDefs", "modules", "onSelectionChanged", "getRowStyle"])
                        ]))
                  ]))
                : _createCommentVNode("", true),
            (_ctx.selectedView == 'school')
              ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                  (!_ctx.fetchedAllSchools)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_10, [
                        _createVNode(_component_ion_spinner)
                      ]))
                    : _createCommentVNode("", true),
                  _createVNode(_component_ag_grid_vue, {
                    rowData: _ctx.filteredSchools,
                    columnDefs: _ctx.schoolColDefs,
                    style: {"height":"500px"},
                    modules: _ctx.agGridModules,
                    pagination: true,
                    onCellValueChanged: _ctx.onCellValueChanged
                  }, null, 8, ["rowData", "columnDefs", "modules", "onCellValueChanged"])
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createVNode(_component_ion_modal, {
          "is-open": _ctx.modalState.sendMessage,
          onDidDismiss: _cache[30] || (_cache[30] = ($event: any) => (_ctx.modalState.sendMessage = false))
        }, {
          default: _withCtx(() => [
            _createVNode(_component_ion_header, null, {
              default: _withCtx(() => [
                _createVNode(_component_ion_toolbar, null, {
                  default: _withCtx(() => [
                    (_ctx.selectedView == 'secondary-school-student')
                      ? (_openBlock(), _createBlock(_component_ion_title, { key: 0 }, {
                          default: _withCtx(() => [
                            _createTextVNode("Send message to " + _toDisplayString(_ctx.recipientStudents.length) + " student" + _toDisplayString(_ctx.recipientStudents.length > 1 ? 's' : ''), 1)
                          ]),
                          _: 1
                        }))
                      : (_openBlock(), _createBlock(_component_ion_title, { key: 1 }, {
                          default: _withCtx(() => [
                            _createTextVNode("Send message to " + _toDisplayString(_ctx.recipientTeachers.length) + " teacher" + _toDisplayString(_ctx.recipientTeachers.length > 1 ? 's' : ''), 1)
                          ]),
                          _: 1
                        })),
                    _createVNode(_component_ion_buttons, { slot: "end" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_button, {
                          onClick: _cache[26] || (_cache[26] = ($event: any) => (_ctx.modalState.sendMessage = false))
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_icon, {
                              slot: "icon-only",
                              icon: _ctx.close
                            }, null, 8, ["icon"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_ion_toolbar, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_item, {
                      href: "https://docs.google.com/spreadsheets/d/1kw9NswTxpI2HrKJAc3bTJnNDfOsCoceJkzmIcCPNSiI/edit?gid=1478216460#gid=1478216460",
                      target: "_blank",
                      detail: "",
                      button: ""
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_label, null, {
                          default: _withCtx(() => _cache[48] || (_cache[48] = [
                            _createTextVNode("17/F, F Tower: WhatsApp terminal (Outbox)")
                          ])),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_ion_content, { class: "ion-padding" }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.msgVariables, (description, key) => {
                  return (_openBlock(), _createBlock(_component_ion_item, {
                    key: key,
                    onClick: ($event: any) => (_ctx.insertVariableAtCursor(key)),
                    button: ""
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_icon, {
                        slot: "start",
                        icon: _ctx.add,
                        style: {"margin":"0"}
                      }, null, 8, ["icon"]),
                      _createVNode(_component_ion_label, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_chip, { class: "small-chip" }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(key), 1)
                            ]),
                            _: 2
                          }, 1024),
                          _createTextVNode(" " + _toDisplayString(description), 1)
                        ]),
                        _: 2
                      }, 1024)
                    ]),
                    _: 2
                  }, 1032, ["onClick"]))
                }), 128)),
                _createVNode(_component_ion_textarea, {
                  id: "messageTextarea",
                  class: "ion-margin-top",
                  modelValue: _ctx.msgOptions.content,
                  "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((_ctx.msgOptions.content) = $event)),
                  fill: "outline",
                  rows: 5,
                  "label-placement": "floating",
                  label: "Message"
                }, null, 8, ["modelValue"]),
                _createVNode(_component_ion_button, {
                  onClick: _cache[28] || (_cache[28] = ($event: any) => (_ctx.sendMessage())),
                  expand: "block",
                  color: "success",
                  disabled: !_ctx.msgOptions.content
                }, {
                  default: _withCtx(() => _cache[49] || (_cache[49] = [
                    _createTextVNode("Send")
                  ])),
                  _: 1
                }, 8, ["disabled"]),
                (_ctx.selectedView == 'secondary-school-student')
                  ? (_openBlock(), _createBlock(_component_ion_button, {
                      key: 0,
                      class: "ion-margin-top",
                      onClick: _cache[29] || (_cache[29] = ($event: any) => (_ctx.sendMsgsToRelatedClassTeachers())),
                      expand: "block",
                      disabled: !_ctx.msgOptions.content
                    }, {
                      default: _withCtx(() => _cache[50] || (_cache[50] = [
                        _createTextVNode("Send to related class teachers")
                      ])),
                      _: 1
                    }, 8, ["disabled"]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["is-open"]),
        _createVNode(_component_ion_modal, {
          "is-open": _ctx.modalState.jupasChoiceConditions,
          onDidDismiss: _cache[36] || (_cache[36] = ($event: any) => (_ctx.closeJUPASChoiceConditionModal()))
        }, {
          default: _withCtx(() => [
            _createVNode(_component_ion_header, null, {
              default: _withCtx(() => [
                _createVNode(_component_ion_toolbar, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_title, null, {
                      default: _withCtx(() => _cache[51] || (_cache[51] = [
                        _createTextVNode("JUPAS Choice Conditions")
                      ])),
                      _: 1
                    }),
                    _createVNode(_component_ion_buttons, { slot: "end" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_button, {
                          onClick: _cache[31] || (_cache[31] = ($event: any) => (_ctx.closeJUPASChoiceConditionModal()))
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_icon, {
                              slot: "icon-only",
                              icon: _ctx.close
                            }, null, 8, ["icon"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createElementVNode("div", _hoisted_11, [
                  _createVNode(_component_ion_chip, {
                    outline: _ctx.selectedJupasSetId !== 'new',
                    color: "primary",
                    onClick: _cache[32] || (_cache[32] = ($event: any) => (_ctx.selectJupasSet('new')))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_label, null, {
                        default: _withCtx(() => _cache[52] || (_cache[52] = [
                          _createTextVNode("New")
                        ])),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["outline"]),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.jupasSets, (set) => {
                    return (_openBlock(), _createBlock(_component_ion_chip, {
                      key: set.id,
                      outline: _ctx.selectedJupasSetId !== set.id,
                      color: "primary",
                      onClick: ($event: any) => (_ctx.selectJupasSet(set.id))
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_label, null, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(set.name), 1)
                          ]),
                          _: 2
                        }, 1024),
                        _createVNode(_component_ion_icon, {
                          icon: _ctx.pencil,
                          onClick: _withModifiers(($event: any) => (_ctx.startRenameSet(set)), ["stop"]),
                          style: {"margin-left":"2px","font-size":"18px"}
                        }, null, 8, ["icon", "onClick"])
                      ]),
                      _: 2
                    }, 1032, ["outline", "onClick"]))
                  }), 128)),
                  (_ctx.selectedJupasSetId === 'new' && _ctx.isJupasDirty)
                    ? (_openBlock(), _createBlock(_component_ion_button, {
                        key: 0,
                        size: "small",
                        color: "success",
                        onClick: _ctx.saveNewJupasSet
                      }, {
                        default: _withCtx(() => _cache[53] || (_cache[53] = [
                          _createTextVNode(" Save ")
                        ])),
                        _: 1
                      }, 8, ["onClick"]))
                    : _createCommentVNode("", true)
                ]),
                _createVNode(_component_ion_alert, {
                  "is-open": _ctx.renameSetModalOpen,
                  header: "Rename Condition Set",
                  inputs: [{ name: 'newName', type: 'text', value: _ctx.renameSetInitialName, placeholder: 'New set name' }],
                  buttons: [
            { text: 'Cancel', role: 'cancel', handler: () => { _ctx.renameSetModalOpen = false; } },
            { text: 'OK', handler: (data) => _ctx.confirmRenameSet(data.newName) }
          ],
                  onDidDismiss: _cache[33] || (_cache[33] = ($event: any) => (_ctx.renameSetModalOpen = false))
                }, null, 8, ["is-open", "inputs", "buttons"]),
                _createVNode(_component_ion_alert, {
                  "is-open": _ctx.addSetPromptOpen,
                  header: "Name for this Condition Set",
                  inputs: [{ name: 'newSetName', type: 'text', value: _ctx.addSetPromptName, placeholder: 'e.g. Band 1 Only' }],
                  buttons: [
            { text: 'Cancel', role: 'cancel', handler: () => { _ctx.addSetPromptOpen = false; } },
            { text: 'Save', handler: (data) => { _ctx.addSetPromptOpen = false; _ctx.confirmAddSetPrompt(data.newSetName); } }
          ],
                  onDidDismiss: _cache[34] || (_cache[34] = ($event: any) => (_ctx.addSetPromptOpen = false))
                }, null, 8, ["is-open", "inputs", "buttons"])
              ]),
              _: 1
            }),
            _createVNode(_component_ion_content, { class: "ion-padding" }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.localJupasConditions, (condition, idx) => {
                  return (_openBlock(), _createBlock(_component_ion_card, { key: idx }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_item, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_checkbox, {
                            justify: "start",
                            labelPlacement: "end",
                            modelValue: condition.isNecessary,
                            "onUpdate:modelValue": ($event: any) => ((condition.isNecessary) = $event)
                          }, {
                            default: _withCtx(() => _cache[54] || (_cache[54] = [
                              _createTextVNode("And?")
                            ])),
                            _: 2
                          }, 1032, ["modelValue", "onUpdate:modelValue"]),
                          _createVNode(_component_ion_checkbox, {
                            justify: "start",
                            labelPlacement: "end",
                            modelValue: condition.isClientProgram,
                            "onUpdate:modelValue": ($event: any) => ((condition.isClientProgram) = $event)
                          }, {
                            default: _withCtx(() => _cache[55] || (_cache[55] = [
                              _createTextVNode("Client Program?")
                            ])),
                            _: 2
                          }, 1032, ["modelValue", "onUpdate:modelValue"]),
                          _createVNode(_component_ion_buttons, { slot: "end" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_button, {
                                onClick: ($event: any) => (_ctx.localJupasConditions.splice(idx, 1))
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ion_icon, { icon: _ctx.close }, null, 8, ["icon"])
                                ]),
                                _: 2
                              }, 1032, ["onClick"])
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        _: 2
                      }, 1024),
                      _createVNode(_component_ion_segment, {
                        mode: "ios",
                        modelValue: condition.targetEntityType,
                        "onUpdate:modelValue": ($event: any) => ((condition.targetEntityType) = $event)
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(['Program', 'Discipline', 'Discipline Group'], (entityType) => {
                            return _createVNode(_component_ion_segment_button, {
                              key: entityType,
                              value: entityType
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(entityType), 1)
                              ]),
                              _: 2
                            }, 1032, ["value"])
                          }), 64))
                        ]),
                        _: 2
                      }, 1032, ["modelValue", "onUpdate:modelValue"]),
                      (condition.targetEntityType)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                            (condition.targetEntityType == 'Discipline Group')
                              ? (_openBlock(), _createBlock(_component_ion_select, {
                                  key: 0,
                                  label: `Select ${condition.targetEntityType}(s)`,
                                  "label-placement": "floating",
                                  modelValue: condition.targetDisciplineGroups,
                                  "onUpdate:modelValue": ($event: any) => ((condition.targetDisciplineGroups) = $event),
                                  "compare-with": (a, b) => a.id === b.id,
                                  interface: "popover",
                                  multiple: "",
                                  fill: "outline"
                                }, {
                                  default: _withCtx(() => [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.disciplineGroups, (disciplineGroup) => {
                                      return (_openBlock(), _createBlock(_component_ion_select_option, {
                                        key: disciplineGroup.id,
                                        value: disciplineGroup
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(disciplineGroup.name), 1)
                                        ]),
                                        _: 2
                                      }, 1032, ["value"]))
                                    }), 128))
                                  ]),
                                  _: 2
                                }, 1032, ["label", "modelValue", "onUpdate:modelValue", "compare-with"]))
                              : (_openBlock(), _createBlock(_component_ion_textarea, {
                                  key: 1,
                                  label: `Select ${condition.targetEntityType}(s)`,
                                  "label-placement": "floating",
                                  rows: 5,
                                  fill: "outline",
                                  value: _ctx.getTargetEntityNames(condition),
                                  clearInput: true,
                                  onClick: ($event: any) => (_ctx.openEntitySelectModal(condition)),
                                  style: {"font-size":"18px !important"}
                                }, null, 8, ["label", "value", "onClick"]))
                          ]))
                        : _createCommentVNode("", true),
                      _createVNode(_component_ion_select, {
                        label: "Target Choice Range",
                        "label-placement": "floating",
                        value: _ctx.ordersProxy(condition),
                        onIonChange: ($event: any) => (_ctx.onOrdersChange($event, condition)),
                        interface: "popover",
                        multiple: "",
                        fill: "outline"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_select_option, {
                            value: '__select_all__',
                            selected: _ctx.isAllSelected(condition)
                          }, {
                            default: _withCtx(() => _cache[56] || (_cache[56] = [
                              _createElementVNode("b", null, "Select All", -1)
                            ])),
                            _: 2
                          }, 1032, ["selected"]),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Array.from({length: 20}, (_, i) => i), (idx) => {
                            return (_openBlock(), _createBlock(_component_ion_select_option, {
                              key: idx,
                              value: idx+1
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.getBandLabel(idx)) + " (" + _toDisplayString(_ctx.getNumOfStudents(idx, condition)) + ") ", 1)
                              ]),
                              _: 2
                            }, 1032, ["value"]))
                          }), 128))
                        ]),
                        _: 2
                      }, 1032, ["value", "onIonChange"])
                    ]),
                    _: 2
                  }, 1024))
                }), 128)),
                _createElementVNode("div", _hoisted_13, [
                  _createVNode(_component_ion_fab, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_fab_button, {
                        onClick: _cache[35] || (_cache[35] = ($event: any) => (_ctx.localJupasConditions.push({ orders: [], targetEntityType: 'Program', targetPrograms: [], targetDisciplines: [], targetDisciplineGroups: [], isNecessary: false, isClientProgram: false })))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_icon, { icon: _ctx.add }, null, 8, ["icon"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["is-open"])
      ]),
      _: 1
    })
  ], 64))
}